<div class="flex flex-col items-stretch gap-5">
    <div class="flex flex-col gap-2">
        <span class="font-bold" i18n>Upload file and categorize</span>
        <span class="text-sm" i18n>Select a file from your computer or drag the file to the box below:</span>
    </div>
    <div class="grid grid-cols-2 gap-5">
        <div class="w-full p-5 rounded-2xl border-2 border-iota-outline flex flex-col gap-5" [formGroup]="form">
            <select class="select select-bordered w-full" formControlName="businessPartnerNumber">
                <option [ngValue]="null" i18n>Select Office</option>
                <option *ngFor="let office of offices$ | ngrxPush" [ngValue]="office?.companyOfficeNumber">
                    {{ office?.name }}<ng-container *ngIf="office?.deactivated" i18n> (deactivated)</ng-container>
                </option>
            </select>
            <select class="select select-bordered w-full" formControlName="documentType">
                <ng-container *ngIf="isHwp; else allOptions">
                    <option [ngValue]="healthyWorkplaceReportDocumentType">
                        {{ documentTypeLabelMap?.[healthyWorkplaceReportDocumentType] }}
                    </option>
                </ng-container>
                <ng-template #allOptions>
                    <option disabled [ngValue]="null" i18n>Select Document Type</option>

                    <option *ngFor="let documentType of allDocumentTypes" [ngValue]="documentType">
                        {{ documentTypeLabelMap?.[documentType] }}
                    </option>
                </ng-template>
            </select>

            <input type="date" class="input input-bordered" formControlName="date" />
        </div>
        <app-document-upload
            buttonText="Select file"
            i18n-buttonText
            (filesSelected)="fileChanged($event)"
            #uploadDocumentInput
        ></app-document-upload>
    </div>
</div>
